"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaders = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _constants = require("../constants");
const getHeaders = headersParams => {
  const getRequestHeaders = (0, _checkoutUtils.getHeadersGetter)(_constants.APP_NAME);
  return getRequestHeaders(headersParams);
};
exports.getHeaders = getHeaders;